import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';

const LoadingDialog = ({title, open, buttonAction, buttonLabel}) => (
    <Dialog
        title={title}
        actions={<FlatButton label={buttonLabel} onClick={buttonAction} />}
        modal={false}
        open={open}
        onRequestClose={buttonAction}
    >
        <CircularProgress />
    </Dialog>
);

LoadingDialog.propTypes = {
    title: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    buttonLabel: PropTypes.string,
    buttonAction: PropTypes.func
};

LoadingDialog.defaultProps = {
    buttonLabel: 'Close',
    buttonAction: f => f,
};

export default LoadingDialog;
